import { exceptionTypeMap } from './types';

export const FINDING_STATE_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Undetected',
};

export const FILTER_FIELD_LABEL_MAPPINGS: Record<string, Record<string, string>> = {
  'exception.type': exceptionTypeMap,
  status: { COMPLETED: 'Complete', FAILED: 'Failed', PARTIALLY_SUCCESSFUL: 'Partially Completed' },
  severity: { HEALTHY: 'Healthy', LOW: 'Low', HIGH: 'High' },
  freshness: { FRESH: 'Fresh', PARTIALLY_FRESH: 'Partially Fresh', NON_FRESH: 'Non-fresh (Stale)' },
  accuracy: { ACCURATE: 'Accurate', POTENTIALLY_NOT_ACCURATE: 'Potentially not Accurate', NOT_ACCURATE: 'Not Accurate' },
};
